import React from 'react';
import NavLinksProps from "./props";
import "./styles.scss";

function NavLinks(props: NavLinksProps) {
  return (
      <nav className="nav-links">
          {props.navigationLinks.map((link, index) => (
            <div className="nav-links-item" key={index} data-e2e="nav-links-item">
              <a  
                href={link.route} 
                onClick={(e) => {
                  props.handleNavLinkClick?.(e);
                  link.onClick?.(e);
                }}
                {...link.additionalAttributes}
              >
                {link.name}
              </a>
              { Array.isArray(link.links) && link.links.length > 0 && <div className="nav-links-sublist" data-e2e="nav-links-sublist">
                {link.links?.map((subLink, subIndex) => (
                  <a 
                    key={subIndex}
                    href={subLink.route} 
                    onClick={(e) => {
                      props.handleNavSubLinkClick?.(e);
                      subLink.onClick?.(e);
                    }}
                    {...subLink.additionalAttributes}
                  >
                    {subLink.name}
                  </a>
                ))}
              </div>}
            </div>
          ))}
        </nav>
  );
}

export default React.memo(NavLinks);